import {
  FETCH_USER_CONFIGURATIONS_START,
  FETCH_USER_CONFIGURATIONS_SUCCESS,
  FETCH_USER_CONFIGURATIONS_FAILURE,
  SEARCH_CITIES_START,
  SEARCH_CITIES_SUCCESS,
  SEARCH_CITIES_FAILURE,
  SEARCH_STATES_FAILURE,
  SEARCH_STATES_SUCCESS,
  SEARCH_STATES_START,
  SEARCH_LOCATIONS_START,
  SEARCH_LOCATIONS_SUCCESS,
  SEARCH_LOCATIONS_FAILURE,
} from './ActionConstant';

export function fetchUserConfigurationsStart(data) {
  return {
    type: FETCH_USER_CONFIGURATIONS_START,
    data,
  };
}

export function fetchUserConfigurationsSuccess(data) {
  return {
    type: FETCH_USER_CONFIGURATIONS_SUCCESS,
    data,
  };
}

export function fetchUserConfigurationsFailure(error) {
  return {
    type: FETCH_USER_CONFIGURATIONS_FAILURE,
    error,
  };
}

export function searchUserCitiesStart(data) {
  return {
    type: SEARCH_CITIES_START,
    data,
  };
}

export function searchUserCitiesSuccess(data) {
  return {
    type: SEARCH_CITIES_SUCCESS,
    data,
  };
}

export function searchUserCitiesFailure(error) {
  return {
    type: SEARCH_CITIES_FAILURE,
    error,
  };
}

export function searchUserStatesStart(data) {
  return {
    type: SEARCH_STATES_START,
    data,
  };
}

export function searchUserStatesSuccess(data) {
  return {
    type: SEARCH_STATES_SUCCESS,
    data,
  };
}

export function searchUserStatesFailure(error) {
  return {
    type: SEARCH_STATES_FAILURE,
    error,
  };
}

export function searchUserLocationsStart(data) {
  return {
    type: SEARCH_LOCATIONS_START,
    data,
  };
}

export function searchUserLocationsSuccess(data) {
  return {
    type: SEARCH_LOCATIONS_SUCCESS,
    data,
  };
}

export function searchUserLocationsFailure(error) {
  return {
    type: SEARCH_LOCATIONS_FAILURE,
    error,
  };
}
